import React from "react";
import SectionExperience from "./Experience.styled";
import {Color} from "../Common/Colors";
import H2 from "../Common/H2.styled";
import Container from "../Common/Container.styled";
import Tabs from "./Tabs";

const Experience = () => {

    return (
        <SectionExperience id="experience" backgroundColor={Color.cultured}>
            <H2>Experience &amp; Education</H2>
            <Container>
                <Tabs/>
            </Container>
        </SectionExperience>
    );
}

export default Experience;